exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".activity-log-row.header-row > td {\n  padding-top: 1em; }\n\n.activity-log-row .stamp {\n  color: #868686;\n  padding-right: 1em; }\n\n.activity-log-row .text {\n  color: #4a4a4a; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Status/components/SyncPanel/components/scss/activityLogRow.scss
// module id = 909
// module chunks = 1